import * as React from "react";
import { forwardRef } from "react";
const SvgCheck24 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.52422 17.6568L4.57422 12.7068L5.98822 11.2928L9.52572 14.8263L9.52422 14.8278L18.0092 6.34277L19.4232 7.75677L10.9382 16.2428L9.52522 17.6558L9.52422 17.6568Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCheck24);
export default ForwardRef;
